import { useState } from 'react'
import { Flex, Box, Text, Image } from 'rebass/styled-components'
import styled from 'styled-components'
import Modal from 'styled-react-modal'
import { ILink } from '../../../graphql/types/queries/conversation'

const Container = styled(Flex)`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #dadada;
  line-height: 1;
  margin: 8px 4px 8px 0;
  padding: 4px 10px;
  flex-direction: row;
  justify-content: center;
  align-items:center;
  transition: all 200ms ease-in;
  &:hover {
  border: 1px solid #b5b5b5;
  }
`

const X = styled(Text)`
  color: #93a1b0;
  cursor: pointer;
  &:hover{
    color: #ce7129;
  }
`

interface IAttachmentFileProps {
  file: {
    fileName: string,
    mimeType: string,
    data: string | ArrayBuffer | null | undefined,
    size: number,
  },
  onDelete: () => void
}

interface IAttachmentFileFromHSProps {
  file: {
    id: number;
    filename: string;
    mimeType: string;
    width: number;
    height: number;
    _links: {
      self: ILink;
      data: ILink;
      web: ILink;
    };
  }
}

function humanFileSize(size: number) {
  var i = Math.floor(Math.log(size) / Math.log(1024));
  return parseFloat((size / Math.pow(1024, i)).toFixed(2)) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
};

export const AttachmentFile: React.FC<IAttachmentFileProps> = ({ file, onDelete }) => {
  // console.log({ file })
  return (
    <Container >
      <Text fontSize={'12px'} mr={2} style={{ cursor: 'pointer' }} onClick={() => {
        // console.log(file.data)
        if (!file.data) return

        var w = window.open('about:blank');

        // FireFox seems to require a setTimeout for this to work.
        setTimeout(() => {
          if (!w) return
          if (!file.data) return
          w.document.body.appendChild(w.document.createElement('iframe')).src = file.data.toString();
          w.document.body.style.margin = '0';
          w.document.getElementsByTagName("iframe")[0].style.width = '100%';
          w.document.getElementsByTagName("iframe")[0].style.height = '100%';
          w.document.getElementsByTagName("iframe")[0].style.border = '0';
        }, 0);
        // window.open(file.data.toString())
      }}>{file.fileName}</Text>
      <span style={{ color: '#96989a', fontSize: '12px' }}>{humanFileSize(file.size)}</span>
      <X ml={2} onClick={onDelete} >X</X>
    </Container>);
}

export const AttachmentFileFromHS: React.FC<IAttachmentFileFromHSProps> = ({ file }) => {
  const [modalContent, setModalContent] = useState<any | null>(null);
  return (
    <>
      <Container style={{ cursor: 'pointer' }}
        onClick={() => {
          if (file.mimeType.indexOf('image/') > -1) {
            return
          }
          window.open((((file._links || {}).web || {}).href || '').replace(/%20/g, '+'))
        }}>
          {file.mimeType.indexOf('image/') > -1&&(
            <img src={((file._links || {}).web || {}).href || ''} height={80}  onClick={() => {
          if (file.mimeType.indexOf('image/') > -1) {
            setModalContent(<Image style={{ objectFit: 'contain', maxHeight: '70vh' }} src={(((file._links || {}).web || {}).href || '').replace(/%20/g, '+')} />)
            return
          }
        }}/>
          )}
        {/* <Text fontSize={'12px'} mr={2} onClick={() => {
          if (file.mimeType.indexOf('image/') > -1) {
            setModalContent(<Image style={{ objectFit: 'contain', maxHeight: '70vh' }} src={(((file._links || {}).web || {}).href || '').replace(/%20/g, '+')} />)
            return
          }
        }}>{file.filename}</Text> */}
        {file.mimeType.indexOf('image/') > -1 ? (
          <a download={file.filename} href={(((file._links || {}).web || {}).href || '')} title={file.filename}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.979 19.804 4.587 19.412C4.195 19.02 3.99934 18.5493 4 18V15H6V18H18V15H20V18C20 18.55 19.804 19.021 19.412 19.413C19.02 19.805 18.5493 20.0007 18 20H6Z" fill="#344F7A" />
            </svg>

          </a>
        ) : (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill="#344F7A" />
          <path d="M23.2049 11.745C22.3228 9.46324 20.7914 7.48996 18.8 6.06906C16.8086 4.64817 14.4445 3.84193 11.9999 3.75C9.55531 3.84193 7.19122 4.64817 5.19983 6.06906C3.20844 7.48996 1.67705 9.46324 0.794925 11.745C0.73535 11.9098 0.73535 12.0902 0.794925 12.255C1.67705 14.5368 3.20844 16.51 5.19983 17.9309C7.19122 19.3518 9.55531 20.1581 11.9999 20.25C14.4445 20.1581 16.8086 19.3518 18.8 17.9309C20.7914 16.51 22.3228 14.5368 23.2049 12.255C23.2645 12.0902 23.2645 11.9098 23.2049 11.745ZM11.9999 16.875C11.0357 16.875 10.0932 16.5891 9.29152 16.0534C8.48983 15.5177 7.86499 14.7564 7.49601 13.8656C7.12704 12.9748 7.03049 11.9946 7.2186 11.0489C7.4067 10.1033 7.871 9.23464 8.55278 8.55285C9.23456 7.87107 10.1032 7.40677 11.0489 7.21867C11.9945 7.03057 12.9747 7.12711 13.8655 7.49609C14.7563 7.86506 15.5177 8.48991 16.0533 9.2916C16.589 10.0933 16.8749 11.0358 16.8749 12C16.8729 13.2923 16.3587 14.5311 15.4449 15.445C14.5311 16.3588 13.2922 16.873 11.9999 16.875Z" fill="#344F7A" />
        </svg>
        )}
      </Container>
      {!!modalContent && (
        <Modal
          isOpen={!!modalContent}
          onBackgroundClick={() => setModalContent(null)}
          onEscapeKeydown={() => setModalContent(null)}>
          <Flex
            flexDirection={'column'}
            style={{
              margin: '0 auto',
              alignSelf: 'center',
              borderRadius: '20px',
              position: 'relative',
              backgroundColor: 'white',
              padding: '24px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              maxHeight: 'calc(100vh * 0.8)',
              // overflow: 'scroll'
            }}>{modalContent}
            <Box onClick={() => {
              setModalContent(null)
            }} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
              X
            </Box>
          </Flex>
        </Modal>
      )}
    </>);
}